import { Building2, Dumbbell, Gamepad2, GraduationCap, School, Users } from 'lucide-react';
import {
  FaDiscord,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaSnapchat,
  FaTiktok,
  FaYoutube,
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import config from '../../config';

// Keep the keys in sync with the server's utils/communityOptions.js.
export const COMMUNITY_TYPES = {
  school: { label: 'School', icon: School },
  university: { label: 'University', icon: GraduationCap },
  sport_club: { label: 'Sport Club', icon: Dumbbell },
  gaming_club: { label: 'Gaming Club', icon: Gamepad2 },
  company: { label: 'Company', icon: Building2 },
  other: { label: 'Other', icon: Users },
};

export const SOCIAL_NETWORKS = {
  instagram: { label: 'Instagram', icon: FaInstagram },
  x: { label: 'X', icon: FaXTwitter },
  facebook: { label: 'Facebook', icon: FaFacebook },
  tiktok: { label: 'TikTok', icon: FaTiktok },
  youtube: { label: 'YouTube', icon: FaYoutube },
  snapchat: { label: 'Snapchat', icon: FaSnapchat },
  discord: { label: 'Discord', icon: FaDiscord },
  linkedin: { label: 'LinkedIn', icon: FaLinkedin },
};

export const getCommunityLogoUrl = (community) =>
  community?.logo ? `${config.apiUrl}/assets/uploads/${community.logo}` : null;

export const getCommunityTypeLabel = (type, t) =>
  t(`communityType_${type}`, { defaultValue: COMMUNITY_TYPES[type]?.label || type });

export const getCommunityTypeIcon = (type) => COMMUNITY_TYPES[type]?.icon || Users;
